<div class="row">
  <div class="col-lg-4">
    <h4>Aule&nbsp;<span class="badge badge-success badge-pill px-3 font-weight-bold font-16" *ngIf="AuleSedi">{{AuleSedi.length}}</span></h4>
<!--    <label for="user" class="control-label col-form-label" >Aule:</label>-->
<!--    <ng-multiselect-dropdown [settings]="UserDropdownSettings" [placeholder]="'Aule'" id="user" name="categorie" [data]="Aule"-->
<!--                             [(ngModel)]="auleSelezionate" (onFilterChange)="filtroAule($event)">-->
<!--    </ng-multiselect-dropdown>-->
  </div>
  <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center ">
<!--    <button class="btn btn-outline-info" style="width: 100%;" (click)="Add()" type="button">-->
<!--      <i class="fas fa-plus-circle">&nbsp;Aggiungi</i>-->
<!--    </button>-->
    <button class="btn btn-outline-info " style="width: 100%;" (click)="AddNew()" type="button">
      <i class="fas fa-user-circle">  Nuova</i>
    </button>
  </div>
</div>
<br>
<div class="table-responsive" *ngIf="AuleSedi">
  <table class="table bg-white table-hover align-middle mb-0 ">
    <thead>
    <tr>
      <th>Nome</th>
      <th scope="col">Descrizione</th>
      <th scope="col">Azioni</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of AuleSedi">
      <td class="align-middle" >
        <span>
          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
            <i class="fas fa-user-circle"></i>
          </span>
           <span *ngIf="item.nome"> {{item.nome}}</span>
        </span>
      </td>
      <td class="align-middle" >
        <span>
          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
            <i class="fas fa-user"></i>
          </span>
           <span *ngIf="item.descrizione"> {{item.descrizione}}</span>
        </span>
      </td>
      <td class="align-middle" >
        <a href="javascript:void(0)" class="link font-16 text-info font-medium mr-2" (click)='editContact(item)'>
          <i-feather name="edit-3" class="feather-sm"></i-feather>
        </a>
        <a href="javascript:void(0)" ngbTooltip="Elimina" class="link font-16 text-danger font-weight-bold"
           (click)='deleteContact(item)'>
          <i-feather name="trash-2" class="feather-sm"></i-feather>
        </a>
      </td>
    </tr>
    </tbody>
  </table>
</div>
